const getSpecificCookie = (value) => {
  const cookies = document.cookie ? document.cookie.split("; ") : []
  return cookies.find((row) => row.startsWith(`${value}=`))
}

export default getSpecificCookie
